import React from 'react';
import SidebarMenuItem from './SidebarMenuItem';
import AccordionMenuItem from './AccordionMenuItem';
import styles from './MenuCard.module.css';

/**
 * MenuCard Component
 * Groups related menu items in a card container
 * Supports both regular items and accordion items with sub-menus
 */
const MenuCard = ({ items, isCollapsed = false }) => {
  if (isCollapsed) {
    // When collapsed, show items as simple menu items
    return (
      <>
        {items.map((item, index) => {
          if (item.subItems && item.subItems.length > 0) {
            return (
              <AccordionMenuItem
                key={item.path || index}
                icon={item.icon}
                label={item.name}
                path={item.path}
                subItems={item.subItems}
                isCollapsed={isCollapsed}
                color={item.color}
                isVip={item.isVip}
              />
            );
          }
          return (
            <SidebarMenuItem
              key={item.path || index}
              icon={item.icon}
              label={item.name}
              path={item.path}
              isCollapsed={isCollapsed}
              color={item.color}
              isVip={item.isVip}
            />
          );
        })}
      </>
    );
  }

  return (
    <div className={styles.menuCard}>
      {items.map((item, index) => {
        if (item.subItems && item.subItems.length > 0) {
          return (
            <AccordionMenuItem
              key={item.path || index}
              icon={item.icon}
              label={item.name}
              path={item.path}
              subItems={item.subItems}
              isCollapsed={false}
              color={item.color}
              isVip={item.isVip}
              className={styles.cardItem}
            />
          );
        }
        return (
          <SidebarMenuItem
            key={item.path || index}
            icon={item.icon}
            label={item.name}
            path={item.path}
            isCollapsed={false}
            color={item.color}
            isVip={item.isVip}
            className={styles.cardItem}
          />
        );
      })}
    </div>
  );
};

export default MenuCard;
